export default __webpack_public_path__ + "static/media/2000.9b2e6a0b.png";